import { social } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  a.yolobot_header_link {
    position: relative;
    background: hsla(0, 0%, 100%, 0.1);
    padding: 6px 14px 6px 30px;
    border-radius: 10px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    width: fit-content;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    text-decoration: none;
  }
  a.yolobot_header_link:hover {
    background: hsla(0, 0%, 100%, 0.2);
    color: #fff;
    text-decoration: none;
  }
  a.yolobot_header_link:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 13px;
    z-index: 99;
    -webkit-mask: url(${social.telegram_logo}) left center / 12px auto no-repeat;
    mask: url(${social.telegram_logo}) left center / 12px auto no-repeat;
    background: #deff00;
    width: 12px;
    height: 100%;
  }
`

const developerCSS = css``

export const TelegramBotButtonCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
